import { Button } from "@dropbox/dig-components/buttons";
import { TargetMissSpot } from "@dropbox/dig-illustrations";
import { EnvCtx } from "@mirage/service-environment-context/global-env-ctx";
import { logout } from "@mirage/service-logout";
import { exit } from "@mirage/service-setting-actions";
import { DashSpinner } from "@mirage/shared/dash-spinner";
import { ShowAfterMinimumDelay } from "@mirage/shared/dash-spinner/DashSpinnerAutofitContainer";
import i18n from "@mirage/translations";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import { Title } from "../BaseProfilePage/Title";
import styles from "./FullPageSpinner.module.css";
import { useReportingIfVisibleForTooLong } from "./useReportingIfVisibleForTooLong";

export const FullPageSpinner: React.FC<{
  // `spinnerId` appears in both Sentry and datadog. Any human-readable id
  // that allows us to quickly understand the source of the spinner easily
  // is good. No need for any rigid naming conventions here.
  spinnerId: string;

  reportingIntervalMs?: number;
}> = ({ spinnerId, reportingIntervalMs }) => {
  const { surface } = EnvCtx;
  const { t } = useTranslation();
  const [isError, setIsError] = useState(false);

  useReportingIfVisibleForTooLong(
    spinnerId,
    () => setIsError(true),
    reportingIntervalMs,
  );

  return (
    <ShowAfterMinimumDelay>
      <div className={styles.fullPage}>
        {isError ? (
          <div className={styles.error}>
            <div className={styles.icon}>
              <TargetMissSpot />
            </div>
            <Title>{t("generic_error_message")}</Title>
            <div className={styles.buttons}>
              <Button
                variant="transparent"
                onClick={() => logout("user--spinner_timeout")}
              >
                {t("log_in_again_button")}
              </Button>
              <Button
                variant="primary"
                onClick={() =>
                  surface === "desktop"
                    ? exit("restart", null)
                    : window.location.reload()
                }
              >
                {t("reload_page_button")}
              </Button>
            </div>
          </div>
        ) : (
          <DashSpinner size={128} aria-valuetext={i18n.t("loading")} />
        )}
      </div>
    </ShowAfterMinimumDelay>
  );
};
